<template>
  <b-card>
    <b-overlay :show="show" rounded="sm">
      <!-- form -->
      <b-form class="mt-2">
        <validation-observer ref="infoRules" tag="form">
          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">{{ $t("ValidatorForm.Partner_Info") }}</h5>
              <small class="text-muted">{{
                $t("ValidatorForm.Enter_Partner_Info")
              }}</small>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('ValidatorForm.License_Details')"
                label-for="licenseDetails"
              >
                <validation-provider
                  #default="{ errors }"
                  name="licenseDetails"
                  rules="required"
                >
                  <b-form-input
                    id="licenseDetails"
                    v-model="partnerProfile.partner.licenseDetails"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('ValidatorForm.License_Details')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Nationality"
                rules="required"
              >
                <b-form-group
                  :label="$t('ValidatorForm.Your_nationality')"
                  label-for="Nationality"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    id="Nationality"
                    v-model="partnerProfile.partner.nationality"
                    :options="countries"
                    :selectable="
                      (option) => !option.value.includes('nothing_selected')
                    "
                    label="text"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Industry"
                rules="required"
              >
                <b-form-group
                  :label="$t('ValidatorForm.industries_services_belong')"
                  label-for="Industry"
                  :state="errors.length > 0 ? false : null"
                >
                  <div id="app">
                    <treeselect
                      v-model="partnerProfile.partner.industries"
                      :multiple="true"
                      label="Select industries ."
                      :options="industries"
                      @input="handeTreeSelect"
                      :normalizer="
                        $store.state.locale.locale == 'ar'
                          ? normalizerArabic
                          : normalizer
                      "
                    />
                  </div>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Country"
                rules="required"
              >
                <b-form-group
                  :label="$t('ValidatorForm.Country')"
                  label-for="Country"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    id="Country"
                    multiple
                    v-model="partnerProfile.partner.address"
                    :options="countries"
                    :selectable="
                      (option) => !option.value.includes('nothing_selected')
                    "
                    label="text"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('ValidatorForm.Brief_overview_yourself')"
                label-for="Highlights"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Highlights"
                  :rules="`required|max:${$maxHighlightsUser}`"
                >
                  <b-form-textarea
                    id="Highlights"
                    v-model="partnerProfile.partner.highlights"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('ValidatorForm.Brief_overview_yourself')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('ValidatorForm.description_yourself')"
                label-for="description"
              >
                <validation-provider
                  #default="{ errors }"
                  name="description"
                  rules="required"
                >
                  <b-form-textarea
                    id="description"
                    v-model="partnerProfile.partner.description"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('ValidatorForm.description_yourself')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :label="$t('ValidatorForm.description_previous_work')"
                label-for="previousWork"
              >
                <validation-provider
                  #default="{ errors }"
                  name="previousWork"
                  rules="required"
                >
                  <b-form-textarea
                    id="previousWork"
                    v-model="partnerProfile.partner.previousWork"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('ValidatorForm.description_previous_work')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-2 mr-1"
                @click.prevent="validationForm"
              >
                {{ $t("dashboard.SaveChanges") }}
              </b-button>
            </b-col>
          </b-row>
        </validation-observer>
      </b-form>
    </b-overlay>
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  BButton,
  BForm,
  BFormGroup,
  BAlert,
  BFormInput,
  BFormInvalidFeedback,
  BRow,
  BCol,
  BCard,
  BFormTextarea,
  BOverlay,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Experience from "@/views/forms/form-repeater/ExperiencRepeater.vue";
import Institute from "@/views/forms/form-repeater/CertificationRepeater.vue";
import Certificate from "@/views/forms/form-repeater/EducationRepeater.vue";
import FormRepeaterBasic from "@/views/forms/form-repeater/LanguageRepeater.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: {
    Experience,
    Institute,
    Certificate,
    FormRepeaterBasic,
    ValidationProvider,
    ValidationObserver,
    VuePhoneNumberInput,
    Treeselect,
    BFormInvalidFeedback,
    BButton,
    BForm,
    BFormGroup,
    BAlert,
    ToastificationContent,
    BFormInput,
    BRow,
    BCol,
    vSelect,
    BCard,
    BFormTextarea,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  //   props: {
  //     generalData: {
  //       type: Object,
  //       default: () => {},
  //     },
  //   },
  props: {
    partnerProfile: {},
  },
  data() {
    return {
      show: false,
      errorMessage: "",
      isValidNumber: null,
      // formatInd: [],
      country: "",
      state: "",
    };
  },
  computed: {
    // formateIndustries: {
    //   get() {
    //     this.freelancerProfile.freelancer.industries.forEach((element) => {
    //       this.formatInd.push(element._id);
    //     });
    //     return this.formatInd;
    //   },
    //   set(val) {
    //     this.formatInd = val;
    //   },
    // },
    ...mapGetters({
      categories: "profile/getInvestorCategories",
      industries: "profile/getAllIndustries",
      currencies: "currency/getCurrencies",
      // countries: "country/getFilterCountries",
      countries: "country/getCountries",

      user: "auth/user",
      skills: "profile/getAllSkills",
      statesOptions: "country/getAllStates",
    }),
  },
  mounted() {
    this.fetchCategories();
    this.fetchIndustries();
    this.fetchCurrencies();
    this.fetchCountries();
    this.fetchSkills();
  },
  methods: {
    ...mapActions({
      fetchCategories: "profile/retreiveCategories",
      fetchIndustries: "profile/retreiveIndustries",
      fetchCurrencies: "currency/retreiveCurrencies",
      editPartner: "profile/editPartner",
      fetchCountries: "country/retreiveCountries",
      fetchSkills: "profile/retreiveSkills",
      fetchStates: "country/retreiveStates",
    }),
    normalizerArabic(node) {
      return {
        id: node.id,
        label: node.arabicName != null ? node.arabicName : node.label,
        children: node.children,
      };
    },
    normalizer(node) {
      return {
        id: node.id,
        label: node.label,
        children: node.children,
      };
    },
    handeTreeSelect(data) {
      if (data.length > 6) {
        this.partnerProfile.partner.industries.length = 6;
      }
    },
    retreiveStates(data) {
      this.fetchStates(data);
    },
    validationForm() {
      return new Promise((resolve, reject) => {
        resolve(true);
        this.$refs.infoRules.validate().then((success) => {
          if (success) {
            this.show = true;
            const formatIndustries = [];
            const formatSkills = [];
            const formatLocation = [];

            if (this.partnerProfile.partner.industries) {
              this.partnerProfile.partner.industries.forEach((element) => {
                formatIndustries.push({
                  _id: element,
                });
              });
            }

            this.partnerProfile.partner.address.forEach((element) => {
              formatLocation.push(element.value);
            });

            const partnerData = new FormData();
            partnerData.append("userId", this.user._id);
            partnerData.append("userType", "partner");
            partnerData.append(
              "licenseDetails",
              this.partnerProfile.partner.licenseDetails
            );
            partnerData.append(
              "nationality",
              this.partnerProfile.partner.nationality.value
            );
            partnerData.append(
              "industries",
              JSON.stringify(this.partnerProfile.partner.industries)
            );
            partnerData.append("address", JSON.stringify(formatLocation));

            partnerData.append(
              "highlights",
              this.partnerProfile.partner.highlights
            );
            partnerData.append(
              "description",
              this.partnerProfile.partner.description
            );
            partnerData.append(
              "previousWork",
              this.partnerProfile.partner.previousWork
            );

            this.editPartner(partnerData)
              .then((response) => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: this.$t("messages.Modified_successfully"),
                    icon: "EditIcon",
                    variant: "success",
                  },
                });
                this.show = false;
              })
              .catch((error) => {
                this.errorMessage = error.response.data.error.message;
                this.show = false;
              });
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
  },
};
</script>
